export default "__VITE_ASSET__330b436f__"